// The consent surfaces' shared behavior (vux #86 + #88 — gdpr.md
// "Consents"): the READING MODAL (document names open the document in
// place — a task-rendered partial or a lazy iframe — with a legend across
// several, and Accept meaning "accept having just read it") and the
// GROUPED checkbox's mirror sync (register mode: the visible group box
// drives the hidden per-document checkboxes the API contract reads —
// the POST body never changed shape). Direct ticking stays allowed
// everywhere: the modal is an aid, never a gate. No-ops on pages
// without the markup.

function initConsents() {
	const modalEl = document.getElementById('consentReadModal');
	const group = document.querySelector('input[data-consent-group]');

	// register mode: the group box mirrors into the hidden per-doc
	// checkboxes (former serializes checkboxes as booleans — the ack
	// contract stays exactly what the API reads)
	if (group) {
		group.addEventListener('change', () => {
			document.querySelectorAll('input[data-consent-sync]').forEach((box) => {
				if (box.checked !== group.checked) {
					box.checked = group.checked;
					box.dispatchEvent(new Event('change', { bubbles: true }));
				}
			});
		});
	}

	if (!modalEl || !window.bootstrap) return;
	const accepted = new Set();
	let current = null;

	const panes = [...modalEl.querySelectorAll('[data-consent-pane-body]')];
	const legendItems = [...modalEl.querySelectorAll('[data-consent-pane]')];
	const show = (doc) => {
		current = doc;
		panes.forEach((pane) => {
			const active = pane.dataset.consentPaneBody === doc;
			pane.hidden = !active;
			if (active) {
				const frame = pane.querySelector('iframe[data-src]');
				if (frame && !frame.src) frame.src = frame.dataset.src; // lazy: load on first view
			}
		});
		legendItems.forEach((item) => item.classList.toggle('is-active', item.dataset.consentPane === doc));
	};

	const tick = (box) => {
		if (box && !box.checked) {
			box.checked = true;
			box.dispatchEvent(new Event('change', { bubbles: true }));
		}
	};
	const applyAccepted = () => {
		// per-document box (non-grouped lines + optional documents)
		tick(document.querySelector(`input[data-consent-box="${CSS.escape(current)}"]`));
		// the group box ticks itself once every one of ITS documents was
		// accepted in the modal (unreadable ones can only be ticked by
		// hand). Register carries the keys in data-consent-group-docs;
		// /consent's group holds them inside its data-consents payload.
		if (group && !group.checked) {
			const docs = JSON.parse(group.dataset.consentGroupDocs || group.dataset.consents || '[]')
				.map((entry) => (typeof entry === 'string' ? entry : entry.doc));
			const readable = new Set(panes.map((pane) => pane.dataset.consentPaneBody));
			const readableDocs = docs.filter((doc) => readable.has(doc));
			if (readableDocs.length > 0 && readableDocs.every((doc) => accepted.has(doc))) {
				tick(group);
			}
		}
		const mark = modalEl.querySelector(`[data-consent-pane="${CSS.escape(current)}"] .consent-read-accepted-mark`);
		if (mark) mark.hidden = false;
	};

	document.querySelectorAll('a[data-consent-read]').forEach((link) => {
		link.addEventListener('click', (event) => {
			event.preventDefault(); // no JS = the href still opens the document
			show(link.dataset.consentRead);
			window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
		});
	});
	legendItems.forEach((item) => {
		item.addEventListener('click', () => show(item.dataset.consentPane));
	});
	modalEl.querySelector('#consentReadAccept')?.addEventListener('click', () => {
		if (current === null) return;
		accepted.add(current);
		applyAccepted();
		const next = panes.map((pane) => pane.dataset.consentPaneBody).find((doc) => !accepted.has(doc));
		if (next) show(next);
		else window.bootstrap.Modal.getOrCreateInstance(modalEl).hide();
	});
}

export { initConsents };
